'use strict';

//
//
// Determines whether a slot with the given name exists in an element.
//
function hasSlot(el, name) {
    return el.querySelector(`[slot="${name}"]`) !== null;
}

exports.hasSlot = hasSlot;
